<template>
    <div :style="cssProps" class="tabs-component">
        <div
            :class="[
                'tabs-titles',
                { pill: hasPillStyle, square: hasSquareStyle, 'square-consumption': hasSquareConsumption }
            ]"
            :style="{ 'justify-content': titleAlignment }"
        >
            <div
                v-for="(tab, index) in tabs"
                :class="['tab', { selected: tab.selected }]"
                @click="selectTab(tab, index)"
                :key="index"
                style="display: flex"
            >
                {{ tab.title }}
                <eg-new-tag v-if="tab.new" />
            </div>
        </div>
        <template v-for="(tab, index) in tabs">
            <div v-show="tab.selected" class="tab-content animated faster fadeIn" :key="index">
                <slot :name="'tab-' + (index + 1)"></slot>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    data: () => ({
        tabs: [],
        styles: ['pill', 'square', 'square-consumption'],
        indexTab: 0
    }),
    props: {
        titles: {
            type: Array,
            default: () => []
        },
        tabStyle: {
            type: String,
            default: 'pill'
        },
        titleAlignment: {
            type: String,
            default: 'center'
        },
        colorBorderBottom: {
            default: false,
            type: [String,Boolean]
        }
    },
    methods: {
        selectTab(tab, index) {
            this.tabs.map((tab, index) => {
                tab.selected = false;
                return tab;
            });
            tab.selected = true;
            this.indexTab = index;
            this.$emit('tab-clicked', index);
        }
    },
    created() {
        this.tabs = this.titles.map((tab, index) => {
            if (tab.title) {
                return {
                    title: tab.title,
                    new: tab.new,
                    selected: index === this.indexTab
                };
            }
            return {
                title: tab,
                selected: index === this.indexTab
            };
        });
    },
    watch: {
        titles() {
            this.tabs = this.titles.map((tab, index) => {
                if (tab.title) {
                    return {
                        title: tab.title,
                        new: tab.new,
                        selected: index === this.indexTab
                    };
                }
                return {
                    title: tab,
                    selected: index === this.indexTab
                };
            });
        }
    },
    computed: {
        hasPillStyle: function() {
            return this.tabStyle === this.styles[0];
        },
        hasSquareStyle: function() {
            return this.tabStyle === this.styles[1];
        },
        hasSquareConsumption: function() {
            return this.tabStyle === this.styles[2];
        },
        cssProps() {
            return {
                '--color-border-bottom': !this.colorBorderBottom ? '#eaeaea' : this.colorBorderBottom
            };
        }
    }
};
</script>

<style>
.tabs-component {
    --tab-border-radius: 18px;
}
.tabs-component .tabs-titles {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
.tabs-component .pill.tabs-titles {
    background-color: var(--color--light-gray);
    border-radius: var(--tab-border-radius);
    width: min-content;
    margin: 0 auto;
}
.tabs-component .pill .tab {
    background-color: var(--color--light-gray);
    color: var(--color--medium-blue);
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    font-weight: 600;
    padding: 6px 28px;
    white-space: nowrap;
}
.tabs-component .pill .tab:first-child {
    border-radius: var(--tab-border-radius) 0 0 var(--tab-border-radius);
}
.tabs-component .pill .tab:last-child {
    border-radius: 0 var(--tab-border-radius) var(--tab-border-radius) 0;
}
.tabs-component .pill .tab.selected {
    background-color: var(--color--medium-blue);
    border-radius: var(--tab-border-radius);
    color: #fff;
}

.tabs-component .square .tab {
    border-bottom: 2px solid var(--color-border-bottom);
    color: var(--color--dark-gray);
    font-size: 16px;
    line-height: 19px;
    padding: 12px 30px;
}
.tabs-component .square .tab.selected {
    color: var(--color--light-blue);
    border-bottom: 6px solid var(--color--light-blue);
    font-weight: 700;
}

/* Tabs for consumption */
.tabs-component .square-consumption .tab.selected {
    border-bottom: 4px solid #007bff;
    line-height: 19px;
    font-weight: bold;
    color: #007bff;
    font-size: 13px;
    padding: 0px;
}

.tabs-component .square-consumption .tab {
    border-bottom: 4px solid transparent;
    margin-right: 24px;
    line-height: 19px;
    font-weight: normal;
    color: #707070;
    font-size: 13px;
}

.tabs-component .square-consumption .tab:nth-child(1) {
    width: 70px;
    text-align: center;
}

.tabs-component .square-consumption .tab:nth-child(2) {
    width: 110px;
    text-align: center;
}

@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}

@media screen and (max-width: 1366px) {
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 992px) {
    .tabs-component .pill .tab {
        padding-left: 20px;
        padding-right: 20px;
    }

    .tabs-component .square .tab {
        font-size: 13px;
        padding-left: 16px;
        padding-right: 16px;
    }
}
@media screen and (max-width: 400px) {
    .tabs-component .square .tab {
        font-size: 13px;
    }
}
@media screen and (max-width: 320px) {
    .tabs-component .square .tab {
        font-size: 11px;
    }
}
</style>
